import type {ComponentType} from 'react';
import type {AiChatProTipType} from './ai-chat-pro-tip-type';

export enum ProTipVariant {
  TEXT = 'text',
  IMAGE = 'image',
  COMPONENT = 'component',
}

export enum ProTipSlotLayout {
  DEFAULT = 'default',
  PORTRAIT = 'portrait',
}

interface BaseProTipProps {
  type: AiChatProTipType;
  onDismiss: VoidFunction;
}

export interface TextProTipProps extends BaseProTipProps {
  variant: ProTipVariant.TEXT;
  icon: string;
  message: string;
}

interface VisualProTipPropsBase extends BaseProTipProps {
  title: string;
  description: string;
}

export interface ImageProTipProps extends VisualProTipPropsBase {
  variant: ProTipVariant.IMAGE;
  imageUrl: string;
}

export interface ComponentProTipProps extends VisualProTipPropsBase {
  variant: ProTipVariant.COMPONENT;
  VisualComponent: ComponentType;
  slotLayout?: ProTipSlotLayout;
}

export type AiPromptBoxProTipProps = TextProTipProps | ImageProTipProps | ComponentProTipProps;

export interface ProTipContext {
  userMessageCount: number;
  hasGeneratedDesign: boolean;
  editableTextLayersAvailable: boolean;
  chatId?: string;
  isFirstMessage: boolean;
  isNewChat: boolean;
  isMessageInProgress: boolean;
  firstUserMessageLength?: number;
  hasLoadingAttachments: boolean;
  lastAttachmentDimensions?: {
    width: number;
    height: number;
  };
}
